<template>
  <div class="event-dropdown" :class="{ 'event-dropdown--open': open }">
    <button type="button" class="event-dropdown__display" @click="toggle()">
      <span class="event-dropdown__display--value" v-if="selected">
        {{ selected.label }}
      </span>
      <span class="event-dropdown__display--label" v-else>
        {{ label }}
      </span>
      <div
        class="event-dropdown__caret"
        :class="
          open ? 'event-dropdown__caret--up' : 'event-dropdown__caret--down'
        "
      ></div>
    </button>
    <div class="event-dropdown__backdrop" v-if="open" @click="toggle()"></div>
    <Transition name="event-dropdown__options--toggle">
      <ul class="event-dropdown__options" v-show="open">
        <button
          type="button"
          v-for="opt in options"
          :key="opt.value"
          class="event-dropdown__option"
          :class="{ 'event-dropdown__option--selected': selected === opt }"
          @click="select(opt)"
        >
          {{ opt.label }}
        </button>
      </ul>
    </Transition>
  </div>
</template>

<script>
export default {
  name: 'EventDropdown',
  props: {
    value: {},
    label: String,
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { selected: null, open: false }
  },
  methods: {
    toggle(direction = null) {
      this.open = direction !== null ? direction : !this.open
    },
    select(option) {
      this.$emit(
        'change',
        this.selected ? this.selected.value : null,
        option.value
      )
      this.selected = option
      this.toggle(false)
      this.$emit('input', option.value)
    },
  },
  mounted() {
    if (this.value) {
      const selected = this.options.find(x => x.value === this.value)
      if (selected) {
        this.select(selected)
      }
    }
  }
}
</script>
